<template lang="html">
  <div class="product productChoose">

    <div class="productImage" href="">

      <div class="imageContent">

        <img
          v-if="dataOrder.order_info.product_image_url==null"
          :src="'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png' "
        >
        <img class="img-table" v-else :src="dataOrder.order_info.product_image_url " >

      </div>

    </div>

    <div class="product-content">

      <div class="product-etiquetas-price">

        <div class="price">


         <span v-if="isNaN(dataOrder.partial_price)">
             <span class="productName"   >$ {{dataOrder.realPrice}} </span>
          </span>
          <span v-else-if="dataOrder.partial_price === 0 ">
             <span class="productName"   >$ {{dataOrder.realPrice}} </span>
          </span>

          <span v-else>
             <span  style="text-decoration-line: line-through;  color: #716d68;  font-size: .8em;" >$ {{dataOrder.realPrice}}</span>  <span style="  color: #716d68;  font-size: .8em;" v-if="dataOrder.partial_price !==0 "> - $ {{dataOrder.partial_price}}</span><br>
          </span>






          <span class="productCode ">#{{dataOrder.order_info.order_code}}</span>
          <span class="productName">{{dataOrder.order_info.weight_kg}} Kg</span>
          <span class="productName product-truncate bold">{{dataOrder.order_info.product_info}}</span>
        </div>

      </div>

      <div class="ctrls por clearfix">

        <div class="cantidad">

          <input class="num ctrl-num" type="text"   v-bind:value="dataOrder.number_of_items" numeric v-bind:min="1" v-bind:max="dataOrder.order_info.product_specimens"  style="width:35px">
          <!-- <div class="arrows">
              <div class="up ctrl-max disabled"></div>
              <div class="down ctrl-min"></div>
          </div> -->
        </div>
        <div class="cantidad2">
            <input   v-if="isNaN(dataOrder.partial_price)" :placeholder="0" @keydown="noPuntoComa($event)"   @keypress="onlyNumber " class="num ctrl-num" type="text"  v-model="updatePrice"    v-on:input="updatePrecio($event.target.value)"  style="width:80px;height:40px"  >
            <input   v-else  :placeholder="dataOrder.partial_price"  @keydown="noPuntoComa($event)"   @keypress="onlyNumber " class="num ctrl-num" type="text"  v-model="updatePrice"    v-on:input="updatePrecio($event.target.value)"  style="width:80px;height:40px" >
        </div>
        <button class="btn btn-danger proAdd " type="button" @click="alertQuitPackage"><i class="fas fa-times"></i></button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['dataOrder'],
  data() {
    return {
      updatePrice: '',
      packagesToSave: [],
    }
  },
  created() {},
  methods: {
    alertQuitPackage() {
      console.log('Click en quit')
      console.log(this.dataOrder)
      this.$emit('quit-package', this.dataOrder)
    },
    updatePrecio: function () {
      return this.dataOrder.partial_price = parseFloat(this.updatePrice)
    },
    onlyNumber ($event) {
    let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
    if ((keyCode < 48 || keyCode > 57 ) && keyCode !== 46  ) {
        $event.preventDefault();
     }

    },


  //mètodo para no permitir punto y coma.
  //  noPuntoComa( $event ) {
  //   let e = $event || window.$event;
  //   let key = e.keyCode || e.which;

  //   if ( key === 110 || key === 190 || key === 188 ) {

  //      e.preventDefault();
  //   }

  //   }

    }

  }

</script>



// WEBPACK FOOTER //
// card-delete-orders.vue?22e9ba4e